__turbopack_context__.v({
  "button": "style-module-scss-module__uBCbga__button",
  "component": "style-module-scss-module__uBCbga__component",
  "floating": "style-module-scss-module__uBCbga__floating",
  "in-modal": "style-module-scss-module__uBCbga__in-modal",
  "not-visible": "style-module-scss-module__uBCbga__not-visible",
  "popover": "style-module-scss-module__uBCbga__popover",
});
